import $ from "jquery";

const findInputForName = function (form, name) {
  return form.find("input, select, textarea").filter(function () {
    const thisName = $(this).attr("name");
    return thisName.match(new RegExp("\\[" + name + "\\(?"));
  });
};

const applyErrors = function (form, errors) {
  for (let key of Object.keys(errors)) {
    const errorMessage = errors[key].join(", ");
    const input = findInputForName(form, key);
    const group = input.closest(".form-group");
    group.addClass("has-error");
    group.append(`<span class="help-block">${errorMessage}</span>`);
  }
};

export function removeAllErrors(form) {
  form.find(".form-group").removeClass("has-error");
  form.find(".form-group .help-block").remove();
}

export function renderBootstrapErrors(form, errors) {
  removeAllErrors(form);
  applyErrors(form, errors);
}
